export default '4.24.5';
